module.exports = __webpack_public_path__ + "static/media/1.4b893745.png";